<script setup lang="ts">
defineProps<{
  item: {
    title: string
    items: {
      title: string
      link: StoryBlokLink
      tag?: string
    }[]
    icon?: StoryBlokIcon
  }
}>()

const emit = defineEmits(['isMenuOpen'])
</script>

<template>
  <div v-if="item.title" class="flex gap-2.5 items-center lg:ml-2">
    <span class="text-gray-special-light text-xs">{{ item.title.toUpperCase() }}</span>
    <AppIcon v-if="item.icon" size="20" class="text-secondary" v-bind="item.icon" />
  </div>
  <StoryblokLink
    v-for="sectionItem in item.items"
    v-bind="sectionItem.link"
    class="rounded-md text-lg text-secondary px-2.5 py-1.5 justify-between duration-200 flex items-center hover:bg-primary/25 lg:pr-1 lg:py-1.5 lg:text-sm"
    @click="emit('isMenuOpen', false)"
  >
    <span class="ml-7">{{ sectionItem.title }}</span>
    <AppIcon icon="far-angle-right" size="20" class="text-gray-special-light" />
  </StoryblokLink>
</template>

<style lang="scss" scoped>
.router-link-active {
  @apply bg-primary/25 text-primary
}
</style>
